'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.authTokenProvided = authTokenProvided;
exports.authTokenReceived = authTokenReceived;
exports.authTokenRequestFailed = authTokenRequestFailed;
// Dispatched when an auth token is provided at time of app initialization
var AUTH_TOKEN_PROVIDED = exports.AUTH_TOKEN_PROVIDED = 'AUTH_TOKEN_PROVIDED';

function authTokenProvided(authToken) {
    return {
        type: AUTH_TOKEN_PROVIDED,
        authToken: authToken
    };
}

var AUTH_TOKEN_REQUESTED = exports.AUTH_TOKEN_REQUESTED = 'AUTH_TOKEN_REQUESTED';

// An action creator is not required for AUTH_TOKEN_REQUESTED, we simply use the
//  AUTH_TOKEN_REQUESTED action type as the 'submitAction' in onSubmitActions.
//  (see actions/reduxFormSubmitActions.js for more information)


// Dispatched when token is received through an AJAX call
var AUTH_TOKEN_RECEIVED = exports.AUTH_TOKEN_RECEIVED = 'AUTH_TOKEN_RECEIVED';

function authTokenReceived(authToken) {
    return {
        type: AUTH_TOKEN_RECEIVED,
        authToken: authToken
    };
}

var AUTH_TOKEN_REQUEST_FAILED = exports.AUTH_TOKEN_REQUEST_FAILED = 'AUTH_TOKEN_REQUEST_FAILED';

function authTokenRequestFailed(errors) {
    return {
        type: AUTH_TOKEN_REQUEST_FAILED,
        errors: errors
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/authTokenActions.js
// module id = 151
// module chunks = 0